import * as THREE from 'three';
import { useEffect, useState } from 'react';
import { useThree } from '@react-three/fiber';

export function Renderer() {
  const { gl, scene, camera } = useThree(({ gl, scene, camera }) => ({
    gl,
    scene,
    camera,
  }));
  const [listener] = useState(() => new THREE.AudioListener());

  useEffect(() => {
    camera.add(listener);
    gl.setClearColor(0x000000);
    gl.setPixelRatio(window.devicePixelRatio);
    gl.toneMapping = THREE.LinearToneMapping;
    gl.toneMappingExposure = 1.0;
    gl.autoClear = false;
    gl.shadowMap.enabled = true;
    gl.shadowMap.type = THREE.PCFSoftShadowMap;

    scene.traverse((object) => {
      if (object['material']) {
        object['material'].needsUpdate = true;
      }
    });

    return () => {
      camera.remove(listener);
    };
  }, [gl, scene]);

  return null;
}
